import React, { useState, useEffect } from 'react';
import LoginForm from '../components/Auth/LoginForm';
import { login } from '../api';
import GoogleLoginButton from '../components/Auth/GoogleLoginButton';

export default function LoginPage({ onLoginSuccess, onChangeView }) {
  const [loginError, setLoginError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  
  // 콜백 처리를 위한 useEffect
  useEffect(() => {
    const qs = new URLSearchParams(window.location.search);
    const access = qs.get("access");
    const refresh = qs.get("refresh");

    if (access && refresh) {
      // 1. 토큰 저장
      localStorage.setItem("access", access);
      localStorage.setItem("refresh", refresh);

      // 2. URL 정리
      window.history.replaceState({}, "", window.location.pathname);

      // 3. 상위 콜백 호출
      onLoginSuccess?.({ access, refresh });
    }
  }, [onLoginSuccess]);

  const handleLogin = async (email, password) => {
    setSubmitting(true);
    setLoginError(''); // 초기화
    
    try {
      // ✅ 명세서에 따른 응답: { access, refresh, user: { pk, username, email } }
      const res = await login(email, password);
      
      // ✅ 토큰 저장
      localStorage.setItem('access', res.access);
      localStorage.setItem('refresh', res.refresh);
      
      // ✅ user 정보도 저장 (선택사항, 필요시 사용)
      if (res.user) {
        localStorage.setItem('user', JSON.stringify(res.user));
      }
      
      // ✅ 부모 컴포넌트(App.js)에 성공 알림
      onLoginSuccess?.(res);
      
    } catch (err) {
      console.error('로그인 에러:', err);
      
      // ✅ 에러 메시지 처리
      if (
        err.message.includes('No active account') || 
        err.message.includes('Unable to log in')
      ) {
        setLoginError('이메일 또는 비밀번호가 올바르지 않아요');
      } else {
        setLoginError(err.message || '로그인 중 오류가 발생했습니다');
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <LoginForm 
        onSubmit={handleLogin} 
        loginError={loginError} 
        submitting={submitting} 
        onChangeView={onChangeView}
      />
      <GoogleLoginButton />
    </>
  );
}